angular.module('rxrefills', [
    //third party
    'angularLocalStorage',
    'gettext',
    'headroom',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',


    //aprima
    'apEasyScroller',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-utils'

]);